module.exports = __webpack_public_path__ + "static/media/pic1.69a9331a.jpg";